import { Sentiment } from "@edgetier/watchtower-types";
import { IProps } from "./sentiment-icons.types";

/**
 * Filter out any props that aren't sentiment indicators.
 * @param props The props passed to SentimentIcons.
 * @returns An array of sentiments.
 */
export const getSentimentsFromProps = (props: IProps) => {
    const sentimentValues = Object.values(Sentiment) as string[];
    const propNames = Object.keys(props);
    return propNames.filter((propName): propName is Sentiment => sentimentValues.includes(propName));
};
